import { environment } from "@env/environment";
import { type IBaseResponse } from "@interfaces/IBaseResponse";
import { type IGobernanzaAprDetailResponse } from "@modules/gobernanza/interfaces/IGobernanzaAprDetailResponse";
import {
  type IGobernanzaAprFilters,
  type IGobernanzaAprListResponse,
} from "@modules/gobernanza/interfaces/IGobernanzaAprResponse";
import { type IGobernanzaAprUpsertRequest } from "@modules/gobernanza/interfaces/IGobernanzaAprUpsertRequest";

import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Service } from "@angular/core";

@Service()
export class GobernanzaAprService {
  private readonly httpClient = inject(HttpClient);

  getAprs(filters: IGobernanzaAprFilters) {
    let params = new HttpParams();

    const search = filters.search.trim();
    if (search) {
      params = params.set("search", search);
    }
    if (filters.categorySis) {
      params = params.set("categorySis", filters.categorySis);
    }
    if (filters.hasOctocelio !== null) {
      params = params.set("hasOctocelio", String(filters.hasOctocelio));
    }

    return this.httpClient.get<IGobernanzaAprListResponse>(
      `${environment.API_URL}/api/governance/aprs`,
      { params }
    );
  }

  getAprById(id: number) {
    return this.httpClient.get<IGobernanzaAprDetailResponse>(
      `${environment.API_URL}/api/governance/aprs/${id}`
    );
  }

  createApr(request: IGobernanzaAprUpsertRequest) {
    return this.httpClient.post<IGobernanzaAprDetailResponse>(
      `${environment.API_URL}/api/governance/aprs`,
      request
    );
  }

  updateApr(id: number, request: IGobernanzaAprUpsertRequest) {
    return this.httpClient.put<IGobernanzaAprDetailResponse>(
      `${environment.API_URL}/api/governance/aprs/${id}`,
      request
    );
  }

  deleteApr(id: number) {
    return this.httpClient.delete<IBaseResponse>(
      `${environment.API_URL}/api/governance/aprs/${id}`
    );
  }
}
